import useEvent from '@lyearn/core/hooks/useEvent';
import { Trans, useTranslation } from '@lyearn/i18n';
import { Typography, useSnackbar } from '@lyearn/ui';
import useResponse from '@/hooks/useResponse';

import { useMergeFileMutation } from '../graphql/mutations/generated/mergeCategory';
import { CategoryType } from '../types';

interface UseMergeCategoryProps {
  onSuccess?: () => void;
}

function useMergeCategory({ onSuccess }: UseMergeCategoryProps) {
  const { t } = useTranslation();
  const [{ fetching }, executeMergeFile] = useMergeFileMutation();
  const { handleResponse } = useResponse();
  const { showSnackbar } = useSnackbar();

  const onMerge = useEvent(async (category: CategoryType, newParentCategory: CategoryType) => {
    const result = await executeMergeFile({
      data: {
        fileIdToMerge: category.id,
        destinationFileId: newParentCategory.id,
      },
    });
    handleResponse({
      condition: Boolean(result.data?.mergeFile?.destinationFile?.id === newParentCategory.id),
      onSuccess: () => {
        showSnackbar({
          message: (
            <Trans
              components={{ label: <Typography variant="label-02" /> }}
              i18nKey="Discover:Category.Admin.CategoryHasBeenMergedIntoParentCategory"
              values={{
                name: category.name,
                parentName: newParentCategory.name,
              }}
            />
          ),
        });
        onSuccess?.();
      },
    });
  });

  return {
    fetching,
    onMerge,
  };
}

export default useMergeCategory;
